import React, { useState, useEffect } from 'react'
import { Button } from '~/lib/ui/button'
import { Dialog, DialogContent } from '~/lib/ui/dialog'
import { cn } from '~/lib/utils'
import Features from './Features'
import useTranslation, {
  TranslationProvider,
} from '../shared/TranslationProvider'
import translations from './locales.json'

const PostUpgradeDialogInner = (props) => {
  const { t } = useTranslation('PostUpgradeDialog')
  const { open, setOpen, showUpgrade, programLevel, platformName } = props

  return (
    <Dialog
      open={open}
      onOpenChange={setOpen}
      className="rounded-2xl lg:max-w-[37rem] xl:max-w-[37rem]"
    >
      <DialogContent
        className={cn(
          'fix-legacy-hack font-robot max-h-[90vh] overflow-y-auto rounded-2xl ',
          !showUpgrade && 'lg:max-w-3xl xl:max-w-5xl',
        )}
        variant="noHeader"
        dialogCloseClass="text-black"
      >
        {showUpgrade ? (
          <div className="flex h-full min-h-[300px] flex-col items-center justify-center gap-8 bg-white p-8">
            <img
              src="https://www-yns-com.s3.us-east-2.amazonaws.com/images/dashboard/OP+Next+Upgrade.gif"
              className="mx-auto"
            />
            <h1 className="text-center text-2xl font-bold !text-primary">
              {t('upgrading', { platformName: platformName })}
            </h1>
          </div>
        ) : (
          <div className="flex w-full flex-col font-roboto md:flex-row">
            <div className="flex flex-col gap-4 bg-white p-8 pb-0 md:flex-1 md:pb-8">
              <h1 className="!m-0 font-roboto-slab font-medium text-primary">
                {t('welcome', { platformName: platformName })}
              </h1>
              <h3>{t('unlocked_tools')}</h3>
              <Features programLevel={programLevel} />
              <p className="!mb-0 !text-lg !font-medium">
                {t('explore_dashboard')}
              </p>
              <p className="!mb-0 !text-lg !font-medium">{t('get_started')}</p>
              <div className="mb-4 flex items-center gap-4">
                <Button onClick={() => setOpen(false)}>
                  {t('goto_dashboard')}
                </Button>
              </div>
            </div>
            <div className="col-span-1 hidden min-h-[300px] flex-1 items-center justify-center rounded-br-2xl rounded-tr-2xl p-8 md:!visible md:!flex md:bg-intoo-blue-light">
              <img src="https://www-yns-com.s3.us-east-2.amazonaws.com/images/dashboard/OP+Next+Welcome.gif" />
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  )
}

const PostUpgradeDialog = ({
  upgraded = false,
  locale,
  programLevel,
  platformName,
}) => {
  const [open, setOpen] = useState(upgraded)
  const [showUpgrade, setShowUpgrade] = useState(upgraded)

  useEffect(() => {
    if (upgraded) {
      setShowUpgrade(true)
      const timer = setTimeout(() => {
        setShowUpgrade(false)
        // Remove ?upgraded=true from the address bar
        const url = new URL(window.location.href)
        url.searchParams.delete('upgraded')
        window.history.replaceState({}, '', url.pathname + url.search)
      }, 8000)
      return () => clearTimeout(timer)
    }
  }, [upgraded])

  return (
    <TranslationProvider
      locale={locale}
      translations={translations}
      scope={'javascript.components.OpNextUpgrade'}
    >
      <PostUpgradeDialogInner
        open={open}
        setOpen={setOpen}
        showUpgrade={showUpgrade}
        programLevel={programLevel}
        platformName={platformName}
      />
    </TranslationProvider>
  )
}

export default PostUpgradeDialog
